import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mealFor: "",
  mealCount: 1,
  plateCount: "1",
};

const mealSlice = createSlice({
  name: "meal",
  initialState,
  reducers: {
    setMealFor(state, action) {
      state.mealFor = action.payload;
    },
    setMealCount(state, action) {
      state.mealCount = action.payload;
    },
    setGuestInfo(state, action) {
      state.guestInfo = action.payload;
    },
    setPlateCount(state, action) {
      state.plateCount = action.payload;
    },
  },
});

export const { setMealFor, setMealCount, setGuestInfo, setPlateCount } =
  mealSlice.actions;

export default mealSlice.reducer;
